<template>
    <v-card-text>
        <v-row align="center">
            <v-col cols="auto">
                <v-text-field
                    v-model.number="thresholdDays"
                    type="number"
                    label="Порог, дней"
                    style="max-width: 140px"
                    dense
                    @change="fetch">
                </v-text-field>
            </v-col>
            <v-col cols="auto">
                <v-btn color="green" @click="fetch">Обновить</v-btn>
            </v-col>
        </v-row>
        <v-row v-if="loading">
            <v-col cols="12" md="7">
                <v-skeleton-loader type="table-row@3"></v-skeleton-loader>
            </v-col>
        </v-row>
        <div v-if="!loading" style="overflow: auto; border-left: thin solid rgba(255, 255, 255, 0.18) !important;">
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="20"
                class="table__lined">
                <template v-slot:body="{ items }">
                    <tbody>
                    <tr v-for="item in items" :key="item.contractId">
                        <td>
                            <router-link :to="`/contracts/${item.contractId}/edit`">
                                #{{ item.contractNumber }}
                            </router-link>
                        </td>
                        <td>{{ item.phaseText }}</td>
                        <td>{{ item.lawyerName }}</td>
                        <td>{{ item.clientName }}</td>
                        <td>
                            <span :class="item.isStuck ? 'red_link' : ''">
                                {{ item.daysInPhase }}
                            </span>
                        </td>
                        <td>
                            <span v-if="item.isStuck" class="red_link">⚠ застрял</span>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </div>
    </v-card-text>
</template>

<script>
import ReportService from "@/_services/ReportService";

export default {
    name: 'ReportPhaseAging',
    data: function () {
        return {
            loading: false,
            items: [],
            thresholdDays: 30,
            headers: [
                {text: '№ Договора', value: 'contractNumber'},
                {text: 'Этап', value: 'phaseText'},
                {text: 'Юрист', value: 'lawyerName'},
                {text: 'Клиент', value: 'clientName'},
                {text: 'Дней в этапе', value: 'daysInPhase'},
                {text: '', value: 'isStuck', sortable: false},
            ]
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            ReportService.getPhaseAgingReport({thresholdDays: this.thresholdDays}).then(report => {
                this.items = report.items;
                this.loading = false;
            });
        }
    },
    created() {
        this.fetch();
    }
};
</script>

<style scoped>
.red_link {
    color: #ff6f6f !important;
}
</style>
